import Link from 'next/link';
import type React from 'react';
import { cn } from '../../features/shared/utils/cn';
import { useConfig } from '../components/Config';
import ExternalLinkIcon from '../new-assets/external-link.svg';

export const FooterLink = ({
	children,
	href,
	className,
	target,
	...props
}: {
	children: React.ReactNode;
	href: string;
	className?: string;
	target?: string;
	rel?: string;
}) => {
	const isExternal = target === '_blank';
	const { translations } = useConfig();

	return (
		// Legacy behavior due to old next version. Cannot style next/link otherwise
		<Link href={href} legacyBehavior>
			<a
				className={cn(
					'text-white underline',
					'hover:text-secondary-dark hover:bg-secondary-light hover:px-2 hover:py-0.5 hover:rounded-[4px]',
					'focus-visible:text-secondary-dark focus-visible:bg-secondary-light focus-visible:px-2 focus-visible:py-0.5 focus-visible:rounded-[4px]',
					'focus-visible:outline-none focus-visible:border-solid focus-visible:border-[2px] focus-visible:border-highlight',
					className,
				)}
				target={target}
				{...props}
			>
				{children}
				{isExternal && (
					<>
						<ExternalLinkIcon
							className="inline-block w-6 pb-0.5"
							aria-hidden="true"
						/>
						<span className="sr-only">{translations.externalLinkLabel}</span>
					</>
				)}
			</a>
		</Link>
	);
};
